var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mb-0",class:{
            'status-on': _vm.val,
            'scene-off': !_vm.val
        },attrs:{"src":this.$api.getIcon(this.profile.icon),"alt":"Object-Icon","height":_vm.knoIcon.size}})])
}
var staticRenderFns = []

export { render, staticRenderFns }